import * as RadixSelect from '@radix-ui/react-select';
import { forwardRef } from 'react';
import { Input } from '~/components/granular';
import { classNames } from '~/utils/styles';
import type { DropdownTriggerProps } from './DropdownTrigger.types';

export const DropdownTrigger = forwardRef<HTMLElement, DropdownTriggerProps>(
  (
    { customTrigger, className, fixedLabel, hasError, isDisabled, isOpen, id, placeholder, value, ...props },
    forwardedRef,
  ) => {
    const TriggerElement = customTrigger || Input;

    const inputClasses = classNames(
      'cursor-pointer bg-white text-left',
      'invalid:hover:outline-[1px] invalid:hover:outline-red-800 invalid:hover:outline-solid invalid:focus:outline-red-800',
      {
        'border-red-800! outline-red-800!': hasError,
        'border-teal-800 outline-teal-800': isOpen && !hasError,
        'hover:cursor-not-allowed hover:border-neutral-200 disabled:border-neutral-200 disabled:bg-white disabled:text-neutral-400 disabled:placeholder:text-neutral-400':
          isDisabled && !!customTrigger,
        'outline-1 outline-solid': isOpen,
      },
    );
    const triggerContainerClasses = classNames(
      'w-full outline-hidden',
      {
        'hover:[&>div>svg]:text-teal-800': !hasError && !isDisabled,
        '[&>div>svg]:text-red-800': hasError && !isDisabled,
        '[&>div>svg]:text-teal-800': isOpen && !hasError,
      },
      className,
    );

    return (
      <RadixSelect.Trigger className={triggerContainerClasses}>
        <TriggerElement
          className={inputClasses}
          disabled={isDisabled}
          hasError={hasError}
          id={id}
          onChange={(e: Event) => e.preventDefault()}
          placeholder={placeholder}
          ref={forwardedRef}
          rightIcon="ArrowDownSIcon"
          role="textbox"
          value={fixedLabel ? fixedLabel : value}
          {...props}
        />
      </RadixSelect.Trigger>
    );
  },
);
